import { api } from "@/lib/api";

const b64ToU8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

// Called only after an explicit user action (button). Returns {ok, reason}.
export async function enablePush() {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return { ok: false, reason: "no-sw" };
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };
  const { data } = await api.get("/push/public-key");
  if (!data.enabled) return { ok: false, reason: "server" };
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) }));
  await api.post("/push/subscribe", { subscription: sub.toJSON(), device: navigator.userAgent.slice(0, 80) });
  return { ok: true };
}

// Unbinds this device from the current user (and from the server) so the next account never gets the previous one's alerts.
export async function disablePush({ keepPermission = true } = {}) {
  try {
    const sub = await getSubscription();
    if (!sub) return;
    await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } }).catch(() => {});
    if (!keepPermission) await sub.unsubscribe(); else await sub.unsubscribe();
  } catch { /* ignore */ }
}
